import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import SparkMD5 from 'spark-md5';
import axios from 'axios';
import { findFile, breakpointContinueFinish, removeChunk } from '@/api/breakpoint';
export default {
  name: 'HelloWorld',
  data: function data() {
    return {
      file: null,
      fileMd5: '',
      formDataList: [],
      waitUpLoad: [],
      waitNum: 0,
      limitFileSize: false,
      percentage: 0,
      percentageFlage: true,
      customColor: '#409eff'
    };
  },
  created: function created() {},
  methods: {
    // 选中文件的函数
    choseFile: function choseFile(e) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var fileR, file, maxSize;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fileR = new FileReader(); // 创建一个reader用来读取文件流
              file = e.target.files[0]; // 获取当前文件
              maxSize = 5 * 1024 * 1024;
              _this.file = file; // file 丢全局方便后面用 可以改进为func传参形式
              _this.percentage = 0;
              if (file.size < maxSize) {
                fileR.readAsArrayBuffer(file); // 把文件读成ArrayBuffer  主要为了保持跟后端的流一致
                fileR.onload = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
                    var blob, spark, FileSliceCap, start, end, i, fileSlice, formData, params, res, finishList, IsFinish;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          // 读成arrayBuffer的回调 e 为方法自带参数 相当于 dom的e 流存在e.target.result 中
                          blob = e.target.result;
                          spark = new SparkMD5.ArrayBuffer(); // 创建md5制造工具 （md5用于检测文件一致性 这里不懂就打电话问我）
                          spark.append(blob); // 文件流丢进工具
                          _this.fileMd5 = spark.end(); // 工具结束 产生一个a 总文件的md5
                          FileSliceCap = 1 * 1024 * 1024; // 分片字节数
                          start = 0; // 定义分片开始切的地方
                          end = 0; // 每片结束切的地方a
                          i = 0; // 第几片
                          _this.formDataList = []; // 分片存储的一个池子 丢全局
                          while (end < file.size) {
                            // 当结尾数字大于文件总size的时候 结束切片
                            start = i * FileSliceCap; // 计算每片开始位置
                            end = (i + 1) * FileSliceCap; // 计算每片结束位置
                            fileSlice = _this.file.slice(start, end); // 开始切  file.slice 为 h5方法 对文件切片 参数为 起止字节数
                            formData = new window.FormData(); // 创建FormData用于存储传给后端的信息
                            formData.append('fileMd5', _this.fileMd5); // 存储总文件的Md5 让后端知道自己是谁的切片
                            formData.append('file', fileSlice); //当前的切片
                            formData.append('chunkNumber', i); // 当前是第几片
                            formData.append('fileName', _this.file.name); //当前文件的文件名 用于后端文件切片的命名  formData.appen 为 formData对象添加参数的方法
                            _this.formDataList.push({
                              key: i,
                              formData: formData
                            }); // 把当前切片信息 自己是第几片 存入我们方才准备好的池子
                            i++;
                          }
                          params = {
                            fileName: _this.file.name,
                            fileMd5: _this.fileMd5,
                            chunkTotal: _this.formDataList.length
                          };
                          _context.next = 13;
                          return findFile(params);
                        case 13:
                          res = _context.sent;
                          // 全部切完以后 发一个请求给后端 拉当前文件后台存储的切片信息 用于检测有多少上传成功的切片
                          finishList = res.data.file.ExaFileChunk; // 上传成功的切片
                          IsFinish = res.data.file.IsFinish; // 是否是同文件不同命 （文件md5相同 文件名不同 则默认是同一个文件但是不同文件名 此时后台数据库只需要拷贝一下数据库文件即可 不需要上传文件 即秒传功能）
                          if (!IsFinish) {
                            // 当是断点续传时候
                            _this.waitUpLoad = _this.formDataList.filter(function (all) {
                              return !(finishList && finishList.some(function (fi) {
                                return fi.FileChunkNumber === all.key;
                              })); // 找出需要上传的切片
                            });
                          } else {
                            _this.waitUpLoad = []; // 秒传则没有需要上传的切片
                          }

                          _this.waitNum = _this.waitUpLoad.length; // 记录长度用于百分比展示
                        case 18:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }();
              } else {
                _this.limitFileSize = true;
                _this.$message('请上传小于5M文件');
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getFile: function getFile() {
      // 确定按钮
      if (this.file == null) {
        this.$message('请先上传文件');
        return;
      }
      this.percentage = Math.floor((this.formDataList.length - this.waitNum) / this.formDataList.length * 100);
      if (this.percentage == 100) {
        this.percentageFlage = false;
      }
      this.sliceFile(); // 上传切片
    },
    sliceFile: function sliceFile() {
      var _this2 = this;
      this.waitUpLoad && this.waitUpLoad.map(function (item) {
        //需要上传的切片
        item.formData.append('chunkTotal', _this2.formDataList.length); // 切片总数携带给后台 总有用的
        var fileR = new FileReader(); // 功能同上
        var file = item.formData.get('file');
        fileR.readAsArrayBuffer(file);
        fileR.onload = function (e) {
          var spark = new SparkMD5.ArrayBuffer();
          spark.append(e.target.result);
          item.formData.append('chunkMd5', spark.end()); // 获取当前切片md5 后端用于验证切片完整性
          _this2.upLoadFileSlice(item);
        };
      });
    },
    upLoadFileSlice: function upLoadFileSlice(item) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var params, res, _params;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return axios.post(process.env.VUE_APP_BASE_API + "/fileUploadAndDownload/breakpointContinue", item.formData);
            case 2:
              _this3.waitNum--; // 百分数增加
              if (!(_this3.waitNum == 0)) {
                _context3.next = 12;
                break;
              }
              // 切片传完以后 合成文件
              params = {
                fileName: _this3.file.name,
                fileMd5: _this3.fileMd5
              };
              _context3.next = 7;
              return breakpointContinueFinish(params);
            case 7:
              res = _context3.sent;
              if (!res.success) {
                _context3.next = 12;
                break;
              }
              // 合成文件过后 删除缓存切片
              _params = {
                fileName: _this3.file.name,
                fileMd5: _this3.fileMd5,
                filePath: res.data.filePath
              };
              _context3.next = 12;
              return removeChunk(_params);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    inputChange: function inputChange() {
      this.$refs.Input.dispatchEvent(new MouseEvent('click'));
    }
  }
};